import * as ngxMarkdown from 'ngx-markdown'

import { Extension } from './extension'

/**
 * Provides {@link ngxMarkdown} and registers any {@link Extension}
 */
export function provideMarkdown() {
  return ngxMarkdown.provideMarkdown({
    markedExtensions: [
      {
        multi: true,
        provide: ngxMarkdown.MARKED_EXTENSIONS,
        useValue: { extensions: Extension.ALL_INSTANCES },
      },
    ],
  })
}
